<template>

  <svg
    t="1641143458555"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4027"
    width="64"
    height="64"
  ><path d="M853.333333 128H170.666667c-25.6 0-42.666667 17.066667-42.666667 42.666667v682.666666c0 25.6 17.066667 42.666667 42.666667 42.666667h682.666666c25.6 0 42.666667-17.066667 42.666667-42.666667V170.666667c0-25.6-17.066667-42.666667-42.666667-42.666667zM213.333333 810.666667V213.333333h256v597.333334H213.333333z m597.333334 0h-256V213.333333h256v597.333334z" p-id="4028" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLayoutColumn',
} as DefineComponent
</script>